import classNames from "classnames";
import { Field, Form, withFormik } from "formik";
import Container from "pages/_components/Container";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { compose } from "redux";
import Yup from "yup";

import { actions as notificationActions } from "reducers/notification";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions, selectors } from "reducers/checks";
import { actions as fileActions, selectors as multilineFileSelectors } from "reducers/formFields/multilineFile";
import { selectors as sessionSelectors } from "reducers/session";

import Button from "pages/_components/Button";
import ContextMenu from "pages/_components/ContextMenu";
import TextField from "pages/_components/fields/TextField";
import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import EcheqMassiveFile from "pages/forms/_components/_fields/_echeqmassivefile/EcheqMassiveFile";
import Productselector from "pages/forms/_components/_fields/Productselector";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import { saveLocation } from "util/transaction";

import Hint from "pages/_components/hints/Hint";
import PageLoading from "pages/_components/PageLoading";
import { validateEcheqAccounts, getAccountMessage } from "util/checks";
import * as configUtils from "util/config";
import { downloadUrl } from "util/download";
import * as i18n from "util/i18n";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import { CURRENCY_CODE, currencyMap } from "../../../../constants";

const FORM_ID = "echeq.massive.emit";

class EmitMassive extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        accounts: arrayOf(
            shape({
                idProduct: string.isRequired,
            }),
        ).isRequired,
        loggedUser: shape({
            userId: string.isRequired,
        }).isRequired,
        isFetchingDownload: bool,
        accountsFetching: bool.isRequired,
        values: shape({}).isRequired,
        setErrors: func.isRequired,
        fetchingValidateAccount: bool,
        isAvailableAccount: bool,
        setFieldValue: func.isRequired,
        rememberMassiveData: bool,
        summary: shape({}).isRequired,
        isSubmitting: bool.isRequired,
        processedFileData: shape({
            invalidLines: number,
            fileIdentifier: string,
            fileName: string,
            totalAmount: shape({
                quantity: number,
                currency: string,
            }),
        }).isRequired,
        currency: string.isRequired,
        isRetailEnvironment: bool.isRequired,
        history: shape({
            location: shape({
                pathname: string,
            }),
        }).isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
        isFetchingDownload: false,
        fetchingValidateAccount: false,
        isAvailableAccount: false,
        rememberMassiveData: false,
    };

    state = {
        fileUploaded: false,
    };

    componentDidMount() {
        const {
            dispatch,
            accounts,
            loggedUser,
            setFieldValue,
            rememberMassiveData,
            summary,
            currency,
            isRetailEnvironment,
        } = this.props;

        dispatch(actions.setGoBackEmitMassive(false));
        if (rememberMassiveData && summary?.file) {
            setFieldValue("account", summary?.account?.idProduct);
            setFieldValue("description", summary?.reference);
        } else {
            dispatch(actions.cleanMassiveSummary());
            dispatch(fileActions.onFileRemoved());
            setFieldValue("account", "");
            setFieldValue("description", "");
        }

        saveLocation(this.props);
        if (!accounts.length > 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId, true, "form", true));
        } else if (
            configUtils.getBoolean("frontend.show.echeqsActions.text.functionalities") &&
            validateEcheqAccounts(accounts, true, currency)
        ) {
            const message = getAccountMessage(currency, isRetailEnvironment);
            dispatch(notificationActions.showNotification(configUtils.get(message), "warning", ["form"]));
        }
        this.applyV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop) {
            this.applyV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell, history } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch, { nextPathname: history?.location?.pathname || "" });
        }
    }

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["echeqs"],
            headerTitle: i18n.get(FORM_ID),
            goBackPath: "/echeqs",
            rightContentMobile: !isDesktop ? this.rightContent() : undefined,
        });
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(push("/echeqs"));
    };

    handleDownload = () => {
        const termsAndConditions = configUtils.get("frontend.MassiveEcheq.file.download.example");
        downloadUrl(termsAndConditions || "");
    };

    renderDownloadDropdown = (isFetchingDownload) => (
        <div className="toolbar-item--fixed align-items-center justify-content-end">
            <Button
                block
                label="echeq.massive.download"
                loading={isFetchingDownload}
                image="images/download.svg"
                onClick={() => this.handleDownload()}
                className="btn-outline cmf-button-width"
                imageStyle="mr-2"
            />
        </div>
    );

    rightContent = () => {
        const { isDesktop, isFetchingDownload } = this.props;

        if (isDesktop) {
            return (
                <Col className="p-0 d-flex space-between align-items-center" xs={12}>
                    <div className="toolbar-item justify-content-end">
                        {this.renderDownloadDropdown(isFetchingDownload)}
                    </div>
                </Col>
            );
        }

        return (
            <ContextMenu
                isDesktop={isDesktop}
                color="white"
                buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                items={[
                    {
                        label: "echeq.massive.download",
                        onClick: () => this.handleDownload(),
                        icon: "SendDown",
                    },
                ]}
            />
        );
    };

    renderHeader = () => {
        const { isDesktop, embeddedInV3Shell } = this.props;
        const hideMobileLegacyHeader = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;

        if (hideMobileLegacyHeader) {
            return null;
        }

        return (
            <>
                {isDesktop && <Head onBack={this.handleBack} />}
                <Head
                    onBack={!isDesktop && this.handleBack}
                    title={FORM_ID}
                    titleClassName="my-0 align-center"
                    messageTooltip={isDesktop ? `${FORM_ID}.title.help` : undefined}
                    rightContent={() => this.rightContent()}
                    headerClassName={!isDesktop ? "blue-main-header-mobile" : "mb-3"}
                    hintClassName="max-width-none"
                />
            </>
        );
    };

    onChangeAccount = (account) => {
        const { dispatch, accounts, setErrors } = this.props;
        const selAccount = accounts.find((object) => object.idProduct === account);
        dispatch(actions.validateAccountEmit("CBU", selAccount?.cbu, setErrors));
    };

    render() {
        const {
            accounts,
            accountsFetching,
            isDesktop,
            embeddedInV3Shell,
            values,
            fetchingValidateAccount,
            isAvailableAccount,
            processedFileData,
            rememberMassiveData,
            isSubmitting,
            currency,
        } = this.props;
        const { fileUploaded } = this.state;
        const accountsFilter = accounts?.filter(
            (account) =>
                account.currency === (currency ? currencyMap[currency] : CURRENCY_CODE.ARS) &&
                account.productType === "CC" &&
                account?.permiteChequera === "SI",
        );
        const hasErrorFile = processedFileData?.invalidLines > 0;

        const continueButton = (
            <Col lg={3} xl={3} md={9} sm={12}>
                <Row className={`${!isDesktop && "ml-0 mr-0"}`}>
                    <div className="admin-content-center">
                        <Button
                            type="submit"
                            bsStyle="primary"
                            label="global.continue"
                            disabled={!values.file || values.file.length < 1 || hasErrorFile}
                            loading={fetchingValidateAccount || isSubmitting}
                        />
                    </div>
                </Row>
            </Col>
        );

        return (
            <PageLoading loading={accountsFetching}>
                {!embeddedInV3Shell && <Notification scopeToShow="form" />}
                <div className="admin-detail-head w-100 px-0 mb-0">{this.renderHeader()}</div>
                <Form autoComplete="off">
                    <div className="above-the-fold">
                        <Container
                            className="flex-grow align-items-center container-white my-2 pb-1"
                            gridClassName="form-content">
                            <Col sm={12} md={9} lg={6} className="align-items-center">
                                {!isDesktop ? (
                                    <Hint
                                        idMessage={`${FORM_ID}.title.help${!isDesktop ? ".mobile" : ""}`}
                                        classNameGroup="my-0"
                                        classNameImage="mt-0 mb-0 justify-content-center align-self-center"
                                        alwaysShowMessage
                                    />
                                ) : (
                                    undefined
                                )}
                                <Col sm={12} className="px-0">
                                    <Field
                                        name="account"
                                        component={Productselector}
                                        idField="account"
                                        data={{
                                            emptyOptionLabel: "",
                                            options: accountsFilter,
                                        }}
                                        disabled={accountsFilter.length === 0}
                                        isRequired
                                        mode="edit"
                                        labelText="transfers.debitaccount.label"
                                        idForm={FORM_ID}
                                        isDesktop={isDesktop}
                                        customPlaceholder={i18n.get("transfers.productSelector.placeholder")}
                                        onCustomChange={this.onChangeAccount}
                                    />
                                </Col>
                                <Col sm={12} className="px-0">
                                    <Field
                                        component={TextField}
                                        renderAs="input"
                                        hidePlaceholder
                                        idForm={FORM_ID}
                                        maxLength="100"
                                        name="description"
                                        type="text"
                                        formGroupClassName={!isDesktop ? "mb-0" : ""}
                                        optional={i18n.get("form.field.optional")}
                                        errorClassName={classNames({
                                            "p-absolute": isDesktop,
                                        })}
                                    />
                                </Col>

                                {true && (
                                    <Col sm={12} className="px-0 mt-3">
                                        <div className="new-payment-multiline-file">
                                            <Field
                                                name="file"
                                                component={EcheqMassiveFile}
                                                type="multilinefile"
                                                mode="edit"
                                                formVersion="1"
                                                sub_type="echeqMassive"
                                                formTitle="echeqMassive"
                                                allowMultiple="false"
                                                acceptedFileTypes="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                useForTotalAmount="true"
                                                maxFileSizeMB="4"
                                                idField="file"
                                                idForm="echeqMassive"
                                                isRequired
                                                fileUploaded={fileUploaded}
                                                values={values}
                                                FORM_ID={FORM_ID}
                                                rememberMassiveData={rememberMassiveData}
                                                enabledUpload={isAvailableAccount && !fetchingValidateAccount}
                                            />
                                        </div>
                                    </Col>
                                )}
                            </Col>
                        </Container>
                    </div>
                    <Container className="flex-grow align-items-center my-2" gridClassName="form-content">
                        {continueButton}
                    </Container>
                </Form>
            </PageLoading>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    accounts: accountsSelectors.getAccounts(state),
    loggedUser: sessionSelectors.getUser(state),
    accountsFetching: accountsSelectors.getFetching(state),
    fetchingValidateAccount: selectors.getFetchingValidateAccount(state),
    isAvailableAccount: selectors.isAvailableAccount(state),
    rememberMassiveData: selectors.getRememberMassiveData(state),
    summary: selectors.getEmitMassiveEcheqData(state),
    processedFileData: ownProps?.processedFileData || multilineFileSelectors.getProcessedFileData(state),
    currency: selectors.getCurrencySelected(state),
    isRetailEnvironment: sessionSelectors.isRetailEnvironment(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({
            account: "",
            file: null,
            description: "",
        }),
        validationSchema: () =>
            Yup.lazy((values) =>
                Yup.object().shape({
                    account: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                    file: values.file
                        ? Yup.array()
                              .of(Yup.object())
                              .min(1, i18n.get(`${FORM_ID}.field.error.required`))
                        : Yup.array().notRequired(),
                }),
            ),
        handleSubmit: ({ account, description }, formikBag) => {
            const { props } = formikBag;
            const { dispatch, accounts, processedFileData, summary } = props;
            const emitAccount = accounts.find(({ idProduct }) => idProduct === account);
            // En fastrack-api 13.x el endpoint /files.upload dejó de propagar el form-data
            // "currency", por lo que processedFileData.totalAmount llega sin currency.
            // Caemos al currency de la cuenta seleccionada para no enviar null al preview/send,
            // ya que parseAmount de v13 rechaza Amounts con currency blank (ARBCMFIMP-18684).
            const resolvedCurrency = processedFileData?.totalAmount?.currency ?? emitAccount?.currency ?? "0";

            const emitMassiveEcheqData = {
                file: processedFileData?.filesMetadata,
                emision: emitAccount?.cbu,
                account: emitAccount,
                reference: description,
                processDate: new Date(),
                echeqsQuantity: processedFileData?.validLines,
                oldBatchId: summary?.batchId,
                higherAmount: {
                    currency: processedFileData?.higherAmount?.currency ?? resolvedCurrency,
                    quantity: processedFileData?.higherAmount?.quantity,
                },
                amountToShow: {
                    currency: resolvedCurrency,
                    quantity: processedFileData?.totalAmount?.quantity,
                },
                echeqsToEmit: [
                    // send one eche for audit
                    {
                        amount: {
                            currency: resolvedCurrency,
                            quantity: processedFileData?.totalAmount?.quantity,
                        },
                    },
                ],
            };
            dispatch(actions.setRememberMassiveData(true));
            dispatch(actions.emitMassiveEcheqPreview(formikBag, emitMassiveEcheqData));
        },
    }),
)(EmitMassive);
